import { BlockId, blockNames, BlockType, SolutionInfo, SupportType } from '../types';

export function createArticleSolutionInfo(data: {
  articleId: string;
  articleType?: SupportType;
  position?: number;
  linkText?: string;
  linkUrl?: string;
  linkSectionText?: string;
}): SolutionInfo {
  return {
    url: data.linkUrl,
    text: data.linkText,
    section_text: data.linkSectionText,
    block_id: BlockId.SingleArticle,
    block_name: blockNames[BlockId.SingleArticle],
    block_position: 1,
    block_type: BlockType.Solution,
    block_details: [
      {
        support_type: data.articleType || SupportType.Article,
        support_id: data.articleId || null,
        support_position: (data.position || 0) + 1,
      },
    ],
  };
}
